'use strict'

let ABC_CONSTANT = require('./constants');
let CUSTOMFIELDV2_MAPPER = require('./customFieldV2Mapping');
let axios = require('axios');
const axiosRetry = require('axios-retry');

/**
 * Header indentifier for CSRF Token
 * @type String
 * @private
 */
const CSRF_TOKEN_HEADER = 'X-CSRF-Token';

/**
 * Data Store for Cancel Token
 * @type Object
 * @private
 */
let _CANCEL_TOKENS = {};
let backboneTokenInfo =  {}; 
let cToolTokenInfo =  {}; 
let mcpTokenInfo =  {}; 

/**
 * Default Handler for Each Network request
 * @param {*} response 
 */
let defaultResponseHandler = function(response) {
    return response.data ? response.data : {};
};

/**
 *  Default Error Object Builder
 * @param {*} error 
 * @returns {} Error Object{ error: boolean, result: string, status: , data: , message?: , headers?:, isCancel?:, info?:};
 */
let _transformErrorResponse = (error) => {
    let errorResponse = {};
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorResponse = {error: true, result: "error", status: error.response.status, data: error.response.data, headers: error.response.headers};
    } else if (axios.isCancel(error)) {
        // This one is intentionally canceled request
        errorResponse = {error: false, result: "canceled", status: null, data: null, message: error.message, isCancel: true};
    } else {
      // Something happened in setting up the request that triggered an Error
      // OR 
      // The request was made but no response was received
      errorResponse = {error: true, result: "error", status: null, data: null, message: error.message, info: "no response received"};
    }
    return errorResponse;
};

/**
 *  Default Handler for Error from Network requests
 * @param {*} error 
 * @param {Number} retryOn409Count Defaults to 0
 * @returns {} Error Object{ error: boolean, status: , data: , message?: , isCancel?:};
 */
let defaultErrorHandler = function(error, retryOn409Count = 0) {
    let errorResponse = _transformErrorResponse(error);
    if(ABC_CONSTANT.debug && console){
        console.error('ABC:ERROR', JSON.stringify(errorResponse));
    }

    // Only for errors
    if(errorResponse.error){

        let hasResponse = _autoRetryOnVersionMismatch(error, errorResponse, retryOn409Count);
        if(hasResponse){
            return hasResponse;
        }
        // Check if it was a time out & trigger event
        _requestTimedOutEvent(errorResponse);
        // Trigger XHR Failed event with information helpful for debugging
        _triggerXhrFailedEvent(errorResponse, error);
    }
    return errorResponse;
};

/**
 * Check if error was request time out & trigger event
 * @param {Object} response 
 */
let _requestTimedOutEvent = (response) => {
    // If error is 408
    if(response.status === 408){
        ABC_CONSTANT._EventBus.dispatch(ABC_CONSTANT.UTIL_EVENTS.REQUEST_TIMEOUT, response);
    }
};

/**
 * Trigger XHR Failed event with information helpful for debugging
 * @param {Object} response 
 * @param {Object} error 
 */
let _triggerXhrFailedEvent = (response, error) => {
    
    let request = {};
    if(error.config){
        // extract request data from axios.config
        request = {
            method: error.config.method,
            url: error.config.url,
            params: error.config.params,
            data: error.config.data,
            headers: error.config.headers,
        };
    }
    ABC_CONSTANT._EventBus.dispatch(ABC_CONSTANT.UTIL_EVENTS.XHR_FAILED, response, request);
};

/**
 * Parse a string as JSON 
 * Returns default value on failure
 * @param {*} v 
 * @param {*} defaultVal 
 */
let getJSON = (v, defaultVal = {}) => {
    try{
        return JSON.parse(v);
    }catch(e){
        return defaultVal;
    }
};

/**
 * Check if request has Version Mismatch
 * Do-retry until retry count reaches zero
 * @param {Object} error 
 * @param {Object} parsedError 
 * @param {Number} retryOn409Count 
 */
let _autoRetryOnVersionMismatch = (error, parsedError, retryOn409Count) => {
    let data = _checkForVersionMismatch(parsedError);
    if(data._callRetry && data._currentVersion && retryOn409Count){
        let method = error.config.method || 'post';
        let requestData = getJSON(error.config.data);
        // An standard Ctool Request will always have version at top
        if(method === 'post' && requestData.version){
            requestData.version = data._currentVersion;
            retryOn409Count--;
            return _makePost(error.config.url, requestData, {headers: error.config.headers}, retryOn409Count);
        }
        // For add items consolidated endpoint specifically,
        // we would have version deep inside
        else if(method === 'post' && (!requestData.version && requestData.addLineItemAction && requestData.addLineItemAction.version)){
            requestData.addLineItemAction.version = data._currentVersion;
            retryOn409Count--;
            return _makePost(error.config.url, requestData, {headers: error.config.headers}, retryOn409Count);
        }
    }
    return null;
};

/**
 * 
 * @param {Error} e 
 */
let defaultValidationErrorHandler = function(e){
    return Promise.resolve({error: true, result: "error", status: null, data: null, message: e.message, validationError: true});
};

/**
 * Exact copy of axios util.encode
 * node_modules\axios\lib\helpers\buildURL.js
 * @param {String} val 
 */
let encode = val => {
    return encodeURIComponent(val).
        replace(/%40/gi, '@').
        replace(/%3A/gi, ':').
        replace(/%24/g, '$').
        replace(/%2C/gi, ',').
        replace(/%20/g, '+').
        replace(/%5B/gi, '[').
        replace(/%5D/gi, ']');
};

/**
 * Overwritten version of axios buildURL
 * node_modules\axios\lib\helpers\buildURL.js
 * @param {Object} params 
 * @param {String} arrayKeySuffix 
 */
let paramsSerializer = (params, arrayKeySuffix = '') => {
    let parts = [];

    Object.keys(params).map(key => {
        let val = params[key];

        if (typeOf(val, 'array')) {
            key = key + arrayKeySuffix;
        }

        if (!typeOf(val, 'array')) {
            val = [val];
        }
        for(let i = 0, len = val.length; i < len; i++) {
            if (typeOf(val[i], 'date')) {
                val[i] = val[i].toISOString();
            } else if (typeOf(val[i], 'object')) {
                val[i] = JSON.stringify(val[i]);
            }
            parts.push(encode(key) + '=' + encode(val[i]));
        }
    });

    return parts.length ? parts.join('&') : null;
};

/**
 * Default Handler for all GET request
 * @param {String} url 
 * @param {Object} requestData 
 * @param {Object} headers 
 * @param {Function} paramsSerializer 
 */
let makeGETRequest = function(url, requestData, headers, paramsSerializer){
    let params = requestData ? requestData : {};
    // Logic for cache busting
    params._ = (new Date()).getTime();
    let config = {
        params: params
    };
    if(!typeOf(headers, 'object')) {
        headers = {};
    }
    // Merge supplied headers 
    if(typeOf(ABC_CONSTANT.headers, 'object')){
        headers = Object.assign(headers, ABC_CONSTANT.headers)
    }
    // pass headers if exists
    if(headers){
        config.headers = headers;
    }
    // pass paramsSerializer if exists
    if(paramsSerializer){
        config.paramsSerializer = paramsSerializer;
    }
    return axios.get(url, config)
        .then(defaultResponseHandler)
        .catch(defaultErrorHandler);
};

/**
 * Default Handler for all POST request
 * @param {String} url 
 * @param {Object} requestPayload 
 * @param {Object} headers 
 * @param {String} cancelIndentifier 
 */
let makePostRequest = function(url, requestPayload, headers = {}, cancelIndentifier = null){
    let config = {};
    if(cancelIndentifier !== null){
        // requested for Cancellation support
        // so lets generate & use `CancelToken`
        if(!typeOf(_CANCEL_TOKENS[cancelIndentifier], 'undefined')){
            // has previous request's cancel token
            // cancel that if in progress
            _CANCEL_TOKENS[cancelIndentifier].cancel('');
        }
        // generate new `CancelToken` & store it for later use
        let CancelToken = axios.CancelToken;
        let CancelTokenSource = CancelToken.source();
        config.cancelToken = CancelTokenSource.token;
        // store `CancelTokenSource` for further uses
        _CANCEL_TOKENS[cancelIndentifier] = CancelTokenSource;
    }

    if(!typeOf(headers, 'object')){
        headers = {};
    }
    // Always overwrite `CSRF_TOKEN_HEADER` from init param if not supplied in headers
    if(typeOf(headers[CSRF_TOKEN_HEADER], 'undefined') && typeOf(ABC_CONSTANT.csrfToken, 'string')){
        headers[CSRF_TOKEN_HEADER] = ABC_CONSTANT.csrfToken;
    }
    // if supplied null then don't send it to request
    else if(typeOf(headers[CSRF_TOKEN_HEADER], 'null')){
        delete headers[CSRF_TOKEN_HEADER];
    }
    // Merge supplied headers 
    if(typeOf(ABC_CONSTANT.headers, 'object')){
        headers = Object.assign(headers, ABC_CONSTANT.headers)
    }
    // pass headers into config
    config.headers = headers;
    return _makePost(url, requestPayload, config, ABC_CONSTANT.retries);
};

/**
 * Default Handler for all DELETE requests
 * @param {String} url 
 * @param {Object} requestData 
 * @param {Object} headers 
 */
let makeDeleteRequest = (url, requestData, headers) => {
    let config = requestData ? {
        params: requestData
    } : {};
    if(!typeOf(headers, 'object')) {
        headers = {};
    }
    // Merge supplied headers 
    if(typeOf(ABC_CONSTANT.headers, 'object')){
        headers = Object.assign(headers, ABC_CONSTANT.headers)
    }
    // pass headers if exists
    if(headers){
        config.headers = headers;
    }
    return axios.delete(url, config)
        .then(defaultResponseHandler)
        .catch(defaultErrorHandler);
};

/**
 * Default Handler for all PUT requests
 * @param {String} url 
 * @param {Object} payload 
 * @param {Object} headers 
 */
let makePutRequest = (url, payload, headers = {}) => {
    if(!typeOf(headers, 'object')) {
        headers = {};
    }
    // Merge supplied headers 
    if(typeOf(ABC_CONSTANT.headers, 'object')){
        headers = Object.assign(headers, ABC_CONSTANT.headers)
    }
    // Always overwrite `CSRF_TOKEN_HEADER` from init param if not supplied in headers
    if(typeOf(headers[CSRF_TOKEN_HEADER], 'undefined') && typeOf(ABC_CONSTANT.csrfToken, 'string')) {
        headers[CSRF_TOKEN_HEADER] = ABC_CONSTANT.csrfToken;
    }
    // if supplied null then don't send it to request
    else if(typeOf(headers[CSRF_TOKEN_HEADER], 'null')) {
        delete headers[CSRF_TOKEN_HEADER];
    }
    return axios.put(url, payload, { headers })
        .then(defaultResponseHandler)
        .catch(defaultErrorHandler);
};

/**
 * Core function that makes post call, 
 * Extracted outside for re-usablity under different purposes
 * @param {String} url 
 * @param {Object} requestPayload 
 * @param {Object} config 
 * @param {Number} retryOn409Count 
 */
let _makePost = (url, requestPayload, config, retryOn409Count = 0) => {
    return axios.post(url, requestPayload, config)
        .then(defaultResponseHandler)
        .catch((e) => {
            return defaultErrorHandler(e, retryOn409Count);
        });
};

/**
 * Check for version Mismatch error and return `_currentVersion` key if happens.
 * @param {Object} data 
 */
let _checkForVersionMismatch = data => {
    if(data.error && data.status && data.status == 409){
        let _data = data.data.errors && data.data.errors[0] ? data.data.errors[0] : {};
        if(_data.currentVersion !== undefined){
            data._callRetry = true;
            data._currentVersion = _data.currentVersion;
            return data;
        }
    }
    return data;
};

/**
 * Call `fnIfVersionChanged` with currentVersion in case of `ConcurrentModification` error
 * @param {Function|Promise} serviceFn : This will be checked for any version Mismatch error
 * @param {Function} fnIfVersionChanged : This will be called with new version of resource
 */
let checkIfVersionMismatch = (serviceFn, fnIfVersionChanged) => {
    if(typeOf(serviceFn, 'function')){
        // in case caller has supplied function instead of promise
        serviceFn = serviceFn.apply();
    }
    // check data from promise for Version Mismatch error
    // if happens then call fnIfVersionChanged with new version
    if(typeOf(serviceFn, 'promise')){
        return serviceFn.then(_checkForVersionMismatch, _checkForVersionMismatch).then(data => {
            if(data._callRetry && typeOf(fnIfVersionChanged, 'function')){
                return fnIfVersionChanged.apply(null, [data._currentVersion]);
            }
            return data;
        });
    }
    return serviceFn;
};

/**
 * Initialize Retry Mechanism
 * 
 * @param {Number} retries 
 * @param {Array} tryForStatus 
 */
let bindRetryHandler = (retries, tryForStatus = []) => {
    axiosRetry(axios, {
        retries,
        retryCondition: (error) => {
            let errorResponse = _transformErrorResponse(error);
            return (
                // isRetryableError = (!error.response || error.response.status >= 500 && error.response.status <= 599)
                (axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error)) &&
                // axiosRetry.isNetworkOrIdempotentRequestError(error) &&
                errorResponse.error &&
                (errorResponse.status === null || tryForStatus.indexOf(errorResponse.status) !== -1)
            );
        }
     });
    
};

/**
 * 
 * @param {*} param 
 */
let buildInitParam = function(param){
    const init = Object.assign(ABC_CONSTANT, param);
    init.baseUrl = init.baseUrl.replace(/\/$/,'');
    init.restPrefix = init.restPrefix.replace(/\/$/,'') + "/";
    init.abcGatewayPrefix = init.abcGatewayPrefix ? ( init.abcGatewayPrefix.replace(/\/$/,'') + "/" ) : "";
    init.backboneGatewayPrefix = init.backboneGatewayPrefix ? ( init.backboneGatewayPrefix.replace(/\/$/,'') + "/" ) : "";
    // Bind Retry Logic if retries count is supplied while Initializing
    if(ABC_CONSTANT._retryInitialized === undefined && typeOf(init.retries, 'number') && init.retries && typeOf(init.retryStatusCodes, 'array')){
        bindRetryHandler(init.retries, init.retryStatusCodes);
        init._retryInitialized = true;
    }
    // Add Request & Response Interceptors if supplied in Initialization
    if(ABC_CONSTANT._requestInterceptor === undefined && init._Interceptors && init._Interceptors.request && init._Interceptors.request.length == 2){
        init._requestInterceptor = axios.interceptors.request.use( ...init._Interceptors.request);
    }
    if(ABC_CONSTANT._responseInterceptor === undefined && init._Interceptors && init._Interceptors.response && init._Interceptors.response.length == 2){
        init._responseInterceptor = axios.interceptors.response.use( ...init._Interceptors.response);
    }
    // Making updated variable globally avaialble within util
    ABC_CONSTANT = init;
    return init;
};

/**
 * return a string of random characters, 
 * dependent on type of characters to use.
 * 
 * @private
 * @param {number} len 
 * @param {number} type 
 * @returns {string}
 */
let stringGen = function(len, type){
    // type = 0 for Number
    // type = 1 for character
    var text = " ";
    var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (type == 0) {
        charset = "0123456789";
    }
    for (var i = 0; i < len; i++){
        text += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return text;
};

/**
 * generateCustomerNumber
 * generate User friendly Customer Number
 * 
 * @returns {String} customerNumber
 */
let generateCustomerNumber = function(){
    var customerNumber = 'CN'+ stringGen(2, 1) + stringGen(1, 0) + stringGen(2, 1) + '-' + stringGen(2, 0) + stringGen(1, 1) + stringGen(2, 0) + '-' + stringGen(1, 0) + stringGen(1, 1) + stringGen(1, 0);
    return customerNumber.replace(/\s/g, "");
};

/**
 * generate User friendly Order Number
 * @returns {String} orderNumber
 */
let generateOrderNumber = function(){
    var orderNumber = 'ON'+ stringGen(2, 1) + stringGen(1, 0) + stringGen(2, 1) + '-' + stringGen(2, 0) + stringGen(1, 1) + stringGen(2, 0) + '-' + stringGen(1, 0) + stringGen(1, 1) + stringGen(1, 0);
    return orderNumber.replace(/\s/g, "");
};

/**
 * generate User friendly Line Item Number
 * @returns {String} lineItemNumber
 */
let generateLineItemNumber = function(){
    var lineItemNumber = 'IN'+ stringGen(2, 1) + stringGen(1, 0) + stringGen(2, 1) + '-' + stringGen(2, 0) + stringGen(1, 1) + stringGen(2, 0) + '-' + stringGen(1, 0) + stringGen(1, 1) + stringGen(1, 0);
    return lineItemNumber.replace(/\s/g, "");
};

/**
 * Search data set for key : value
 * Optimized version of forEach
 * Update: It can compare in case insensitive manner too
 * Update: Switched to for loop as it is faster than for in loop
 * 
 * @param {Array} dataSouce
 * @param {String} key
 * @param {any} value
 * @param {String} flag
 * 
 * @returns {Object}
 */
let searchFirstByKeyValue = function(dataSouce, key, value, flag){
    var row = {};
    for(var i = 0, len = dataSouce.length; i < len; i++){
        if (dataSouce[i][key] == value){
            row = dataSouce[i];
            break;
        }
        else if(flag && flag == 'i' && dataSouce[i][key] && (new String(dataSouce[i][key])).toLowerCase() == (new String(value)).toLowerCase() ){
            // case insensitive search
            row = dataSouce[i];
            break;
        }
    }
    return row;
};

/**
 * get datatype of property
 * 
 * @param {any} prop 
 * @param {string} type 
 * @returns {boolean}
 */
let typeOf = function(prop, type){
    const dataset = {
        'object': '[object Object]',
        'array': '[object Array]',
        'string': '[object String]',
        'boolean': '[object Boolean]',
        'number': '[object Number]',
        'date': '[object Date]',
        'undefined': '[object Undefined]',
        'null': '[object Null]',
        'promise': '[object Promise]',
        'function': '[object Function]'
    };

    return (Object.prototype.toString.call(prop) === dataset[type]);
};

/**
 * Object of Key Value pair
 * @param {Object} obj 
 */
let objectToSetOfStrings = function(obj){
    // Converting object to set of strings
    return Object.keys(obj).map(function(key) {
        return key + ':' + obj[key];
    });
};

/**
 * Convert Array into Object
 * @param {Array} arr 
 */
let setOfStringsToObject = function(arr){
    var obj = {};
    // Converting set of strings to Object
    for (var i = 0, len = arr.length; i < len; ++i){
        var set = arr[i].split(":");
        if(set.length){
            obj[set[0]] = set[1];
        }
    }
    return obj;
};

/**
 * Return first value of product attribute from value set, depending upon data type of value set
 * @param {Array} values 
 * @param {*} defaultValue 
 */
let getAttributeFirstValue = (values, defaultValue = null) => {
    if(typeOf(values, 'array') && values.length){
        return values[0].key !== undefined ? values[0].key : defaultValue;
    }
    else if(typeOf(values, 'object')){
        return values.key !== undefined ? values.key : defaultValue;
    }
    return defaultValue;
};

/**
 * get number of fraction Digits This currency code supports
 * @param {String} currencyCode 
 */
let currencyCodeToFractionDigits = (currencyCode) => {
    // this list can be updated anytime for "minor unit" from here https://en.wikipedia.org/wiki/ISO_4217
    // if needed we can group by digits & create set of codes
    const config = {
        "EUR": 2,
        "USD": 2,
        "GBP": 2,
        "JOD": 3,
        "JPY": 0,
    };
    // try to search from config set else fallback to 2
    return config[currencyCode] !== undefined ? config[currencyCode] : 2;
};

/**
 * get a HighPrecisionMoney Object
 * @param {String} currencyCode 
 * @param {Number} centAmount 
 */
let getHighPrecisionMoney = (currencyCode, centAmount) => {
    // this will be fractional digits allowed in each currency
    let currencyCentDigits = currencyCodeToFractionDigits(currencyCode);

    return {
        "type": "highPrecision",
        "currencyCode": currencyCode,
        "preciseAmount": Math.round(centAmount * (Math.pow(10, ABC_CONSTANT.precisionDigits))),
        "fractionDigits": (ABC_CONSTANT.precisionDigits + currencyCentDigits)
    };
};


/**
 * utility  function to get/write  both  v1 and v2 custom fields based on the configuration
 * @param {String} fieldName 
 * @param {Object} value 
 * @param {Object} params 
 * @param {Object} customFields 
 */
let getCustomFieldsV2 = (fieldName,value,params,customFields={}) => {
    // this will be fractional digits allowed in each currency
    let mapperResult=CUSTOMFIELDV2_MAPPER[fieldName]();
    if(params.supportV1){
        customFields[mapperResult.v1Field] = value;
    }
    if(params.supportV2){
        customFields[mapperResult.v2Field] = mapperResult.transformer.convertToVersionTwo(value);
        if(customFields[mapperResult.v1Field]!=undefined && !params.supportV1){
            delete customFields[mapperResult.v1Field];
        }
    }
    return customFields;
}

/** 
 * for fetching always the recent version (v2) of the custom field
 * @param {String} fieldName 
 * @param {Object} value 
 */
let getV2TransformedData = (customFields={},fieldName) => {
    // the v1 version name of the field
    fieldName=fieldName.replace("V2","");
    let v2CustomFieldName=CUSTOMFIELDV2_MAPPER[fieldName]().v2Field;
    if(customFields[v2CustomFieldName]!=undefined){
        return customFields[v2CustomFieldName];
    }
    else if(customFields[fieldName]!=undefined){
        let mapperResult=CUSTOMFIELDV2_MAPPER[fieldName]();
        let value=customFields[fieldName]!=undefined?customFields[fieldName]:customFields[v2CustomFieldName];
        return mapperResult.transformer.convertToVersionTwo(value);
    }else{
        return undefined;
    }
}

/** 
 * for fetching always the recent version (v2) of the custom field
 * @param {String} fieldName 
 * @param {Object} value 
 */
let getV1TransformedData = (fieldValue,fieldName) => {
    // the v1 version name of the field
    if(fieldValue==undefined){
        return fieldValue;
    }
    let mapperResult=CUSTOMFIELDV2_MAPPER[fieldName]();
    return mapperResult.transformer.convertToVersionOne(fieldValue);
}


/**
 * wrapper on type of check for v2 fields too
 */
let typeOfV2Compatible = (fieldName,type)=>{

}

module.exports = {
    sendValidationError: defaultValidationErrorHandler,
    paramsSerializer,
    makeGETRequest,
    makePostRequest,
    makeDeleteRequest,
    makePutRequest,
    checkIfVersionMismatch,

    buildInitParam: buildInitParam,
    generateOrderNumber: generateOrderNumber,
    generateLineItemNumber: generateLineItemNumber,
    generateCustomerNumber: generateCustomerNumber,
    typeOf: typeOf,
    objectToSetOfStrings: objectToSetOfStrings,
    setOfStringsToObject: setOfStringsToObject,
    searchFirstByKeyValue: searchFirstByKeyValue,
    getAttributeFirstValue,
    getHighPrecisionMoney,
    getCustomFieldsV2,
    getV2TransformedData,
    getV1TransformedData
};


// WEBPACK FOOTER //
// ./src/core/util.js